interface Positioning {
  displayBelow: boolean;
  maxHeight?: number;
}

export const getMenuPosition = (anchorElement: HTMLElement, menuElement: HTMLElement): Positioning => {
  const intrinsicHeightOfMenu = menuElement.getBoundingClientRect().height;

  const anchorElementRect = anchorElement.getBoundingClientRect();
  const spaceAboveInViewport = anchorElementRect.top;
  const spaceBelowInViewport = window.innerHeight - anchorElementRect.bottom;
  const spaceAboveInDocument = window.scrollY + anchorElementRect.top;
  const spaceBelowInDocument = document.documentElement.scrollHeight - window.scrollY - anchorElementRect.bottom;

  // 1. Does it fit above in the viewport?
  if (spaceAboveInViewport >= intrinsicHeightOfMenu) {
    return { displayBelow: false };
  }

  // 2. Does it fit below in the viewport?
  if (spaceBelowInViewport >= intrinsicHeightOfMenu) {
    return { displayBelow: true };
  }

  // 3. Does it fit above in the document?
  if (spaceAboveInDocument >= intrinsicHeightOfMenu) {
    return { displayBelow: false };
  }

  // 4. Does it fit below in the document?
  if (spaceBelowInDocument >= intrinsicHeightOfMenu) {
    return { displayBelow: true };
  }

  // 5. Nothing left, use position in viewport with more space
  return {
    displayBelow: spaceAboveInViewport < spaceBelowInViewport,
    maxHeight: Math.max(spaceAboveInViewport, spaceBelowInViewport),
  };
};
